/**
 * THE shape every cached read resolves to: all four keys on every path, an
 * unavailable value is `null`. A fresh object each call so a caller that
 * mutates it can't poison later reads.
 */
const emptyFix = () => ({
  latitude: null,
  longitude: null,
  accuracy: null,
  updated_at: null,
});

/** Same calendar day, device-local. */
const isFromToday = (timestamp) => {
  if (!timestamp) return false;
  const then = new Date(timestamp);
  if (Number.isNaN(then.getTime())) return false;
  return then.toDateString() === new Date().toDateString();
};

export const toCachedFix = (fix) => {
  if (!fix || !isFromToday(fix.updated_at)) return emptyFix();
  if (fix.latitude == null || fix.longitude == null) return emptyFix();
  return {
    latitude: fix.latitude,
    longitude: fix.longitude,
    accuracy: fix.accuracy ?? null,
    updated_at: fix.updated_at ?? null,
  };
};
